import { useDispatch, useSelector } from 'react-redux';
import PendingCard from '@/components/Dashboard/DashboardPendings/PendingsCard';
import GenericBarChart from '../../../Charts/GenericBarChart';
import useFetchDashboard from '@/components/Dashboard/customHooks/useFetchDashboard';
import { getOverviewDevelopmentsLocations } from '@/store/slices/components/dashboard/service';
import {
  getBaseUrl,
  getParsedLabels,
  handleClickBar,
  handleTooltip,
} from './utils';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import DashboardEmptyStateCard from '@/components/Dashboard/DashboardEmptyStateCard';
import DevelopmentIcon from '@/public/images/dashboard/development.svg';
import { useTrackOverviewTab } from '@/components/Dashboard/customHooks/useTrackDashboard';

export default function DevelopmentsLocations() {
  const dispatch = useDispatch();
  const { overviewDevelopmentsLocations, miniCards } = useSelector(
    (state) => state.DashboardSlice
  );
  const track = useTrackOverviewTab();
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const { loading, hasFetched, labels, datasets } =
    overviewDevelopmentsLocations;
  const { developmentsValue } = miniCards;

  useFetchOnViewport(
    (query) => {
      dispatch(getOverviewDevelopmentsLocations(query));
    },
    [],
    { hasFetched }
  );

  const parsedLabels = getParsedLabels(labels, Trans(translations, 'Others'));
  const headerUrl = getBaseUrl();

  const translateTooltip = (devs, locationsValue) =>
    Trans(translations, 'CountDevelopmentsInLocations', [devs, locationsValue]);

  return (
    <PendingCard ref={ref} loading={loading || isStale}>
      <PendingCard.Header
        redirectUrl={developmentsValue === 0 ? null : headerUrl}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={(element) => track.developmentLocation(element)}
      >
        {Trans(translations, 'Location')}
      </PendingCard.Header>
      {developmentsValue === 0 ? (
        <DashboardEmptyStateCard
          icon={DevelopmentIcon}
          title={Trans(
            translations,
            'HereYouWillSeeHowManyDevelopmentsYouHaveInEachLocation'
          )}
        />
      ) : (
        <GenericBarChart
          labels={parsedLabels}
          datasets={datasets}
          onBarClick={({ label }) => handleClickBar(label.locationId)}
          getTooltipLabel={(context) =>
            handleTooltip(context, labels, translateTooltip)
          }
        />
      )}
    </PendingCard>
  );
}
